import { useEffect, useState } from "react";
import api from "../../api";
import toast from "../../utils/toast";
import "../UserManager.css";

const BASE = "/api/insumos";

export default function InsumosManager() {
  const [insumos, setInsumos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [nuevo, setNuevo] = useState({
    nombre: "",
    categoria_id: "",
    unidad_medida: "unidad",
    stock_actual: 0,
    stock_minimo: 0,
    activo: true,
  });
  const [editando, setEditando] = useState(null);
  const [err, setErr] = useState("");
  const [soloActivos, setSoloActivos] = useState(false);

  const cargar = async () => {
    try {
      setErr("");
      const url = soloActivos ? `${BASE}/insumos?activos=1` : `${BASE}/insumos`;
      const { data } = await api.get(url);
      setInsumos(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e?.response?.data?.error || e.message);
    }
  };

  const cargarCatUni = async () => {
    try {
      const [rCat, rUni] = await Promise.all([
        api.get(`${BASE}/categorias`),
        api.get(`${BASE}/unidades`),
      ]);
      setCategorias(Array.isArray(rCat.data) ? rCat.data : []);
      setUnidades(Array.isArray(rUni.data) ? rUni.data : ["unidad", "kg", "g", "litro", "ml", "paquete", "caja", "otro"]);
    } catch (_) {
      setCategorias([]);
      setUnidades(["unidad"]);
    }
  };

  useEffect(() => {
    cargarCatUni();
  }, []);

  useEffect(() => {
    cargar();
  }, [soloActivos]);

  const agregar = async () => {
    if (!nuevo.nombre.trim()) return toast("Nombre es obligatorio");
    try {
      await api.post(`${BASE}/insumos`, {
        ...nuevo,
        categoria_id: nuevo.categoria_id || null,
        stock_actual: Number(nuevo.stock_actual) || 0,
        stock_minimo: Number(nuevo.stock_minimo) || 0,
      });
      setNuevo({ nombre: "", categoria_id: "", unidad_medida: "unidad", stock_actual: 0, stock_minimo: 0, activo: true });
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "Error al agregar");
    }
  };

  const guardarEdicion = async () => {
    if (!editando?.nombre?.trim()) return;
    try {
      await api.put(`${BASE}/insumos/${editando.id}`, {
        nombre: editando.nombre,
        categoria_id: editando.categoria_id || null,
        unidad_medida: editando.unidad_medida,
        stock_minimo: Number(editando.stock_minimo),
        activo: editando.activo,
      });
      setEditando(null);
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "Error al actualizar");
    }
  };

  const eliminar = async (item) => {
    if (!window.confirm(`¿Desactivar insumo "${item.nombre}"? No se borra el historial de compras.`)) return;
    try {
      await api.delete(`${BASE}/insumos/${item.id}`);
      setEditando(null);
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "No se pudo desactivar");
    }
  };

  return (
    <div className="um-wrapper">
      <div className="um-card">
        <div className="um-header">
          <div>
            <h2>Insumos</h2>
            <p className="um-subtitle">Stock actual y mínimo; al registrar compras el stock se actualiza solo.</p>
          </div>
          <span className="um-badge">{insumos.length} insumos</span>
        </div>
        <div className="um-form insumos-form-agregar">
          <div className="um-field">
            <label>Nombre</label>
            <input placeholder="Ej: Arroz" value={nuevo.nombre} onChange={(e) => setNuevo({ ...nuevo, nombre: e.target.value })} />
          </div>
          <div className="um-field">
            <label>Categoría</label>
            <select value={nuevo.categoria_id} onChange={(e) => setNuevo({ ...nuevo, categoria_id: e.target.value })}>
              <option value="">—</option>
              {categorias.map((c) => (
                <option key={c.id} value={c.id}>{c.nombre}</option>
              ))}
            </select>
          </div>
          <div className="um-field">
            <label>Unidad</label>
            <select value={nuevo.unidad_medida} onChange={(e) => setNuevo({ ...nuevo, unidad_medida: e.target.value })}>
              {unidades.map((u) => (
                <option key={u} value={u}>{u}</option>
              ))}
            </select>
          </div>
          <div className="um-field">
            <label>Stock actual</label>
            <input type="number" min="0" step="0.001" value={nuevo.stock_actual} onChange={(e) => setNuevo({ ...nuevo, stock_actual: e.target.value })} />
          </div>
          <div className="um-field">
            <label>Stock mín.</label>
            <input type="number" min="0" step="0.001" value={nuevo.stock_minimo} onChange={(e) => setNuevo({ ...nuevo, stock_minimo: e.target.value })} />
          </div>
          <div className="um-actions insumos-form-agregar-btn">
            <button type="button" className="um-btn um-btn-primary" onClick={agregar}>Agregar</button>
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label><input type="checkbox" checked={soloActivos} onChange={(e) => setSoloActivos(e.target.checked)} /> Solo activos</label>
        </div>
        {err && <div className="um-error">Error: {err}</div>}
        <div className="um-table-wrap">
          <table className="um-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Categoría</th>
                <th>Unidad</th>
                <th>Stock</th>
                <th>Mín.</th>
                <th>Estado</th>
                <th className="um-col-actions">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {insumos.map((i) => (
                <tr key={i.id}>
                  {editando?.id === i.id ? (
                    <>
                      <td><input value={editando.nombre} onChange={(e) => setEditando({ ...editando, nombre: e.target.value })} className="um-inline-input" /></td>
                      <td>
                        <select value={editando.categoria_id || ""} onChange={(e) => setEditando({ ...editando, categoria_id: e.target.value })}>
                          <option value="">—</option>
                          {categorias.map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                        </select>
                      </td>
                      <td>
                        <select value={editando.unidad_medida} onChange={(e) => setEditando({ ...editando, unidad_medida: e.target.value })}>
                          {unidades.map((u) => <option key={u} value={u}>{u}</option>)}
                        </select>
                      </td>
                      <td>{Number(editando.stock_actual)}</td>
                      <td><input type="number" min="0" value={editando.stock_minimo} onChange={(e) => setEditando({ ...editando, stock_minimo: e.target.value })} className="um-inline-input" style={{ width: 70 }} /></td>
                      <td><input type="checkbox" checked={editando.activo} onChange={(e) => setEditando({ ...editando, activo: e.target.checked })} /></td>
                      <td className="um-col-actions">
                        <button className="um-btn um-btn-ghost" onClick={guardarEdicion}>Guardar</button>
                        <button className="um-btn um-btn-ghost" onClick={() => setEditando(null)}>Cancelar</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{i.nombre}</td>
                      <td>{i.categoria_nombre || "—"}</td>
                      <td>{i.unidad_medida}</td>
                      <td>{Number(i.stock_actual)}</td>
                      <td>{Number(i.stock_minimo)}</td>
                      <td><span className={i.activo ? "um-pill um-pill-ok" : "um-pill um-pill-off"}>{i.activo ? "Activo" : "Inactivo"}</span></td>
                      <td className="um-col-actions">
                        <button className="um-btn um-btn-ghost" onClick={() => setEditando({ ...i })}>Editar</button>
                        <button className="um-btn um-btn-danger" onClick={() => eliminar(i)}>Eliminar</button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
              {insumos.length === 0 && (
                <tr><td colSpan={7} className="um-empty">No hay insumos.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
